<template>
  <button
    class="btn"
    :class="btnProps.class"
  >
    {{ btnProps.label }}
  </button>
</template>

<script>
export default {
  name: "loans-row-actions",
  props: {
    data: { type: Object },
  },
  computed: {
    btnProps() {
      if (this.data.isSelected) {
        return {
          label: "Eliminar",
          class: "btn-danger",
        };
      }

      return {
        label: "Agregar",
        class: "btn-primary",
      };
    },
  },
};
</script>